import { useSyncExternalStore } from 'react';

/**
 * Magia e Avaliar Inteligência do personagem, para os tooltips das magias (techspec-tooltips-e-efeitos): o número da
 * caixa sai com a skill de agora. O perfil preenche (SkillBar, ao entrar e ao abrir a escolha) e o aviso de ganho (99)
 * soma o +0,1. `null` = ainda não chegou: a caixa mostra sem o número calculado.
 */
export interface SkillsMagia { readonly magery: number | null; readonly evalInt: number | null }

let atual: SkillsMagia = { magery: null, evalInt: null };
const ouvintes = new Set<() => void>();
const avisar = () => { for (const f of ouvintes) f(); };

export function definirSkillsMagia(magery: number | null, evalInt: number | null): void {
  atual = { magery, evalInt };
  avisar();
}

/** O aviso de ganho de skill traz só o +0,1: soma em cima do que já chegou (até 100). */
export function somarSkillMagia(id: string, ganho: number): void {
  if (!Number.isFinite(ganho) || ganho <= 0) return;
  if (id === 'magery' && atual.magery != null) atual = { ...atual, magery: Math.min(100, Math.round((atual.magery + ganho) * 10) / 10) };
  else if (id === 'evalInt' && atual.evalInt != null) atual = { ...atual, evalInt: Math.min(100, Math.round((atual.evalInt + ganho) * 10) / 10) };
  else return;
  avisar();
}

export function skillsMagiaAtuais(): SkillsMagia {
  return atual;
}

function assinar(f: () => void): () => void {
  ouvintes.add(f);
  return () => { ouvintes.delete(f); };
}

export function useSkillsMagia(): SkillsMagia {
  return useSyncExternalStore(assinar, skillsMagiaAtuais, skillsMagiaAtuais);
}
